import {useEffect} from "react"
import * as React from 'react'


export interface EventListenerProps {
    /**
     * The ID used to identify this component in Dash callbacks.
     */
    id?: string
    /**
     * URL of the SSE, for real time updates
     */
    url: string,
    /**
     * Received event message
     */
    message?: string,
    /**
     * Dash-assigned callback that should be called to report property changes
     * to Dash, to make them available for callbacks.
     */
    setProps: (props: Partial<EventListenerProps>) => void
}

const EventListener = ({id, url, setProps}: EventListenerProps) => {

    useEffect(() => {
        console.log('Listening to this endpoint:', url)
        const eventSource = new EventSource(url);


        eventSource.onopen = () => {
            console.log("SSE OPEN");
        };

        eventSource.onmessage = (event) => {
            console.log("SSE message received:", event.data);
            setProps({message: event.data})
        };

        eventSource.onerror = (error) => {
          console.error('EventSource error:', error);
          console.log(
                    "SSE ERROR",
                    error,
                    "readyState=",
                    eventSource.readyState
                );

        };

        return () => {
          // Clean up the event source when the component is unmounted
          eventSource.close();
        };
    }, [url])

    return (<div id={id}/>)
}

export default EventListener